<template>
    <div>
        <div
            class="d-flex align-items-center"
            style="height: 3.5rem; border-bottom: 1px solid #e0e0e0"
        >
            <div style="padding-left: 1.5rem; color: #42a5f5">
                <img class="" src="/icon/gpu-machine-icon.svg" alt="" style="width: 1.5rem" />
                <span class="ml-2" style="font-family: Montserrat">{{
                    this.serviceType === 1 ? "Machine GPU" : "Machine CPU"
                }}</span>
            </div>
            <!-- <div class="ml-3 mr-3">
        <i style="font-size: 1rem" class="el-icon-arrow-right"></i>
      </div>
      <div style="color: #42a5f5">
        <span style="font-family: Montserrat">GPUHub</span>
      </div> -->
        </div>
        <component
            v-bind:is="componentFile"
            @processingEvent="processingEvent"
        ></component>

        <ContextMenuMobile/>

        <!-- CREATE IMAGE -->
        <div class="modal fade" :id="popupId.CREATE_IMAGE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <CreateImage
                        :serviceType="serviceType"
                        :type="rentType"
                        :key="createImageKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- BOOT MACHINE -->
        <div class="modal fade" :id="popupId.BOOT_MACHINE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <BootMachine
                        :targetImage="targetImage"
                        :key="bootMachineKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- DOWNLOAD REMOTE DESKTOP -->
        <div class="modal fade" :id="popupId.DOWNLOAD_REMOTE_DESKTOP">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <DownloadRemoteDesktop
                        :targetImage="targetImage"
                        :key="downloadRemoteDesktopKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- RENAME IMAGE -->
        <div class="modal fade" :id="popupId.RENAME_IMAGE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <RenameImage
                        :targetImage="targetImage"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- SNAPSHOT IMAGE -->
        <!-- <div class="modal fade" :id="popupId.SNAPSHOT_IMAGE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center modal-xl"
            >
                <div class="modal-content">
                    <SnapshotImage
                        :targetImage="targetImage"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div> -->

        <!-- REMOVE IMAGE -->
        <div class="modal fade" :id="popupId.REMOVE_IMAGE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <RemoveImage
                        :targetImage="targetImage"
                        :key="removeImageKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- SHUTDOWN MACHINE -->
        <div class="modal fade" :id="popupId.SHUTDOWN_MACHINE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <ShutdownMachine
                        :targetImage="targetImage"
                        :key="shutdownMachineKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- HARDWARE FIXATION -->
        <div class="modal fade" :id="popupId.HARDWARE_FIXATION">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <HardwareFixation
                        :targetImage="targetImage"
                        :key="hardwareFixationKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- CLONE IMAGE -->
        <div class="modal fade" :id="popupId.CLONE_IMAGE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <CloneImage
                        :targetImage="targetImage"
                        :key="cloneImageKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- SCHEDULER MACHINE -->
        <div class="modal fade" :id="popupId.SCHEDULER_MACHINE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <SchedulerMachine
                        :targetImage="targetImage"
                        :key="schedulerMachineKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- FIXED RENTAL CREATE -->
        <div class="modal fade" :id="popupId.FIXED_RENTAL_CREATE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <FixedRentalCreate
                        :targetImage="targetImage"
                        :key="fixedRentalCreateKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- SETTINGS MACHINE -->
        <div class="modal fade" :id="popupId.SETTINGS_MACHINE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <SettingsMachine
                        :targetImage="targetImage"
                        :key="settingsMachineKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- FIXED RENTAL EXISTING MACHINE -->
        <div class="modal fade" :id="popupId.FIXED_RENTAL_EXISTING_MACHINE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <FixedRentalExistingMachine
                        :serviceType="serviceType"
                        :key="fixedRentalExistingMachineKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- FIXED RENTAL RENEWAL MACHINE -->
        <div class="modal fade" :id="popupId.FIXED_RENTAL_RENEWAL_MACHINE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <FixedRentalRenewalMachine
                        :targetImage="targetImage"
                        :key="fixedRentalRenewalMachineKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- FIXED RENTAL DEACTIVATE -->
        <div class="modal fade" :id="popupId.FIXED_RENTAL_DEACTIVATE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <FixedRentalDeactivate
                        :targetImage="targetImage"
                        :key="fixedRentalDeactivateKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- FIXED RENTAL SETTINGS -->
        <div class="modal fade" :id="popupId.FIXED_RENTAL_SETTINGS">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <FixedRentalSettings
                        :targetImage="targetImage"
                        :key="fixedRentalSettingsKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- RESTART MACHINE -->
        <div class="modal fade" :id="popupId.RESTART_MACHINE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <RestartMachine
                        :targetImage="targetImage"
                        :key="restartMachineKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- RESET MACHINE -->
        <div class="modal fade" :id="popupId.RESET_MACHINE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <ResetMachine
                        :targetImage="targetImage"
                        :key="resetMachineKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- DISCONNECT INTERNET MACHINE -->
        <div class="modal fade" :id="popupId.DISCONNECT_INTERNET_MACHINE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <DisconnectInternetMachine
                        :targetImage="targetImage"
                        :key="disconnectInternetMachineKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- ACTIVATE SOFTWARE LICENSE -->
        <div class="modal fade" :id="popupId.ACTIVATE_SOFTWARE_LICENSE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <ActivateSoftwareLicense
                        :targetImage="targetImage"
                        :key="activateSoftwareLicenseKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- CHANGE SERVICE PACKAGE -->
        <div class="modal fade" :id="popupId.CHANGE_SERVICE_PACKAGE">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <ChangeServicePackage
                        :targetImage="targetImage"
                        :key="changeServicePackageKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>

        <!-- PROCESS MONITORING -->
        <!-- <div class="modal fade" :id="popupId.PROCESS_MONITORING">
      <div
        class="modal-dialog modal-dialog-centered justify-content-center"
        style="max-width: 100%"
      >
        <div class="modal-content" style="width: auto">
          <ProcessMonitoring
            :targetImage="targetImage"
            :key="processMonitoringKey"
            @processingEvent="processingEvent"
          />
        </div>
      </div>
    </div> -->

        <!-- REPORT ISSUES -->
        <div class="modal fade" :id="popupId.EXTRA_SERVICE_REPORT_ISSUES">
            <div
                class="modal-dialog modal-dialog-centered justify-content-center"
                style="max-width: 100%"
            >
                <div class="modal-content">
                    <ExtraServiceReportIssues
                        :targetImage="targetImage"
                        :key="extraServiceReportIssuesKey"
                        @processingEvent="processingEvent"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Event, Dialog
//import EventBus from "@/event/EventBus";

// Constant
import { ROUTE_URL } from "@/constant/route";
import { SERVICE_TYPE } from "@/constant/rental";
import { POPUP_ID } from "@/constant/baseConstant";

// Extend
import base from "@/scripts/base";

//Components
import CreateImage from "@/views/modal/RentalService/CreateImage";
import BootMachine from "@/views/modal/RentalService/BootMachine";
import DownloadRemoteDesktop from "@/views/modal/RentalService/DownloadRemoteDesktop";
import RemoveImage from "@/views/modal/RentalService/RemoveImage";
import ChangeServicePackage from "@/views/modal/RentalService/ChangeServicePackage";
import RenameImage from "@/views/modal/RentalService/RenameImage";
import CloneImage from "@/views/modal/RentalService/CloneImage";
import ShutdownMachine from "@/views/modal/RentalService/ShutdownMachine";
import HardwareFixation from "@/views/modal/RentalService/HardwareFixation";
import SchedulerMachine from "@/views/modal/RentalService/SchedulerMachine";
import RestartMachine from "@/views/modal/RentalService/RestartMachine";
import ResetMachine from "@/views/modal/RentalService/ResetMachine";
import DisconnectInternetMachine from "@/views/modal/RentalService/DisconnectInternetMachine";
import ActivateSoftwareLicense from "@/views/modal/RentalService/ActivateSoftwareLicense";
import SettingsMachine from "@/views/modal/RentalService/SettingsMachine";

import ExtraServiceReportIssues from "@/views/modal/ExtraService/ExtraServiceReportIssues";

import FixedRentalCreate from "@/views/modal/FixedRental/FixedRentalCreate";
import FixedRentalExistingMachine from "@/views/modal/FixedRental/FixedRentalExistingMachine";
import FixedRentalRenewalMachine from "@/views/modal/FixedRental/FixedRentalRenewalMachine";
import FixedRentalDeactivate from "@/views/modal/FixedRental/FixedRentalDeactivate";
import FixedRentalSettings from "@/views/modal/FixedRental/FixedRentalSettings";

import lazyLoadComponent from "@/scripts/lazyLoadComponent";
import SkeletonBox from "@/views/component/SkeletonBox";
import ContextMenuMobile from "@/views/component/RentalService/ContextMenuMobile";

export default {
    extends: base,

    components: {
        ContextMenuMobile,
        FixedRentalCreate,
        FixedRentalExistingMachine,
        FixedRentalRenewalMachine,
        FixedRentalDeactivate,
        FixedRentalSettings,

        SettingsMachine,

        ExtraServiceReportIssues,

        CreateImage,
        BootMachine,
        DownloadRemoteDesktop,
        RemoveImage,
        ChangeServicePackage,
        RenameImage,
        SnapshotImage: lazyLoadComponent({
            componentFactory: () =>
                import("@/views/modal/RentalService/SnapshotImage"),
            loading: SkeletonBox,
        }),
        CloneImage,
        ShutdownMachine,
        HardwareFixation,
        SchedulerMachine,
        RestartMachine,
        ResetMachine,
        DisconnectInternetMachine,
        ActivateSoftwareLicense,
        ProcessMonitoring: lazyLoadComponent({
            componentFactory: () =>
                import("@/views/modal/RentalService/ProcessMonitoring"),
            loading: SkeletonBox,
        }),
    },

    data() {
        return {
            popupId: POPUP_ID,
            targetImage: null,
            serviceType: null,
            rentType: null,

            fixedRentalCreateKey: 0,
            fixedRentalExistingMachineKey: 0,
            fixedRentalRenewalMachineKey: 0,
            fixedRentalDeactivateKey: 0,
            fixedRentalSettingsKey: 0,

            createImageKey: 0,
            bootMachineKey: 0,
            downloadRemoteDesktopKey: 0,
            removeImageKey: 0,
            changeServicePackageKey: 0,
            renameImageKey: 0,
            cloneImageKey: 0,
            shutdownMachineKey: 0,
            hardwareFixationKey: 0,
            schedulerMachineKey: 0,
            restartMachineKey: 0,
            resetMachineKey: 0,
            disconnectInternetMachineKey: 0,
            activateSoftwareLicenseKey: 0,
            processMonitoringKey: 0,

            extraServiceReportIssuesKey: 0,

            settingsMachineKey: 0,
        };
    },

    computed: {
        componentFile() {
            switch (this.serviceType) {
                case SERVICE_TYPE.GPUHUB:
                    return () =>
                        import("@/views/RentalService/GpuHubService.vue");
                case SERVICE_TYPE.CPUHUB:
                    return () =>
                        import("@/views/RentalService/CpuHubService.vue");
                default:
                    return () =>
                        import("@/views/RentalService/GpuHubService.vue");
            }
        },
    },

    watch: {
        $route() {
            this.changeComponent();
        },
    },

    created() {
        this.changeComponent();
    },
    methods: {
        //#region Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },
        //#endregion

        //#region Change componenet
        changeComponent() {
            switch (this.$route.path.substring(1)) {
                case ROUTE_URL.GPUHUB:
                    this.serviceType = SERVICE_TYPE.GPUHUB;
                    break;
                case ROUTE_URL.CPUHUB:
                    this.serviceType = SERVICE_TYPE.CPUHUB;
                    break;
            }
        },
        //#endregion

        //#region Process open pop-up
        processOpenPopup(param) {
            console.log(
                "🚀 ~ file: RentalContainer.vue:533 ~ processOpenPopup ~ param:",
                param
            );
            switch (param.type) {
                case POPUP_ID.CREATE_IMAGE:
                    this.rentType = param.data;
                    break;

                default:
                    this.targetImage = param.data;
                    break;
            }
            this.openPopup(param.type);
            if (param.refresh)
                this[
                    `${
                        param.name.charAt(0).toLowerCase() + param.name.slice(1)
                    }Key`
                ] += 1;
        },
        //#endregion
    },
};
</script>